import { Box } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { detailsTickets } from 'src/redux/Calendar/sliceCalendar';
import { SchedulesMasterUpdateForm } from './SchedulesMasterUpdateForm';
import { SchedulesUpdateForm } from './SchedulesUpdateForm';

export const SchedulesContent = () => {
  const data = useSelector(detailsTickets);
  if (!data) return null;
  return (
    <>
      <SchedulesMasterUpdateForm />
      {Object.keys(data).map((i) => (
        <Box key={i} mb={4}>
          <SchedulesMasterUpdateForm schedule_id={+i} />
          {Object.keys(data[i]).map((date) => (
            <SchedulesUpdateForm
              key={`${i}_${date}`}
              state={data[i][date]}
              date={date}
              schedule_id={i}
            />
          ))}
        </Box>
      ))}
    </>
  );
};
